var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.isLoading)?_c('div',{staticClass:"loading-overlay",staticStyle:{"z-index":"9999999"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"preloader"}},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../assets/images/hotellogo.png"),"alt":""}})]),_c('span',{staticClass:"preloader-dot"})])
}]

export { render, staticRenderFns }